/**
 * 配置编译环境和线上环境之间的切换
 * 
 * baseUrl: 域名地址
 * routerMode: 路由模式
 * imgBaseUrl: 图片所在域名地址
 * backHome：登录页返回首页的地址
 * 
 */


//本地配置  e81d1ea13570472992b1ee7a6471c949
//let baseUrl = 'http://127.0.0.1:8889'; 
//let companyId = '1';
//let routerMode = 'hash';
//let imgBaseUrl = 'http://127.0.0.1:8889';
//let indexHttp = 'http://app.qaqabeauty.com';
//let language = 'cn';
//let locationUrl = 'http://127.0.0.1:80';
//let brandName = '1';
//qaqa配置
// let baseUrl = 'http://api.qaqabeauty.com'; 
// let companyId = 'e81d1ea13570472992b1ee7a6471c949';
// let routerMode = 'hash';
// let imgBaseUrl = 'http://api.qaqabeauty.com';
// let indexHttp = 'http://app.qaqabeauty.com';
// let language = 'cn';
// let locationUrl = 'http://agent.qaqabeauty.com';
// let brandName = 'qaqa';

//privethai配置
// let baseUrl = 'http://api.privethai.com'; 
// let companyId = '1';
// let routerMode = 'hash';
// let imgBaseUrl = 'http://api.privethai.com';
// let indexHttp = 'http://app.privethai.com';
// let language = 'cn';
// let locationUrl = 'http://agent.privethai.com';
// let brandName = 'pvb';

//thn配置
// let baseUrl = 'http://api.thnskin.com'; 
// let companyId = '1';
// let routerMode = 'hash';
// let imgBaseUrl = 'http://api.thnskin.com';
// let indexHttp = 'http://app.thnskin.com';
// let language = 'cn';
// let locationUrl = 'http://agent.thnskin.com';
// let brandName = 'thn';

//talbeylor配置
// let baseUrl = 'http://api.talbeylor.com'; 
// let companyId = '1';
// let routerMode = 'hash';
// let imgBaseUrl = 'http://api.talbeylor.com';
// let indexHttp = 'http://app.talbeylor.com';
// let language = 'cn';
// let locationUrl = 'http://agent.qaqabeauty.com';
// let brandName = 'talbeylor';

//zhuzhubang配置
// let baseUrl = 'http://api.zhuzhubond.com'; 
// let companyId = 'yyc';
// let routerMode = 'hash';
// let imgBaseUrl = 'http://api.zhuzhubond.com';
// let indexHttp = 'http://i.zhuzhubond.com';
// let language = 'cn';
// let locationUrl = 'http://i.zhuzhubond.com';
// let brandName = 'zhuzhubond';

//tipu配置
// let baseUrl = 'http://api.tipu.xin'; 
// let companyId = '1';
// let routerMode = 'hash';
// let imgBaseUrl = 'http://api.tipu.xin';
// let indexHttp = 'http://api.tipu.xin';
// let language = 'cn';
// let locationUrl = 'http://agent.tipu.xin';
// let brandName = 'tipu';

//拾喜配置
// let baseUrl = 'http://bji.tipu.xin'; 
// let companyId = '1';
// let routerMode = 'hash';
// let imgBaseUrl = 'http://bji.tipu.xin';
// let indexHttp = 'http://bji.tipu.xin';
// let language = 'cn';
// let locationUrl = 'http://bj.tipu.xin';
// let brandName = 'tipu';

//nnk配置
let baseUrl = 'http://api.nnk-nongnaka.com'; 
let companyId = '1';
let routerMode = 'hash';
let imgBaseUrl = 'http://api.nnk-nongnaka.com';
let indexHttp = 'http://api.nnk-nongnaka.com';
let language = 'cn';
let locationUrl = 'http://agent.nnk-nongnaka.com';
let brandName = 'tipu';


export {
	baseUrl,
	routerMode,
	companyId,
	imgBaseUrl,
	indexHttp,
	language,
	locationUrl,
	brandName,
}


// WEBPACK FOOTER //
// ./src/config/env.js